<template>
  <div class="text-input">
    <!-- Component Body -->
    <b-form-input 
      :class="inputClasses" 
      id="input" 
      :type="inputType" 
      :placeholder="label" 
      @change="$emit('inputChanged', $event.replace(',', '.'))" 
      :value="value">
    </b-form-input>
  </div>
</template>

<script>
import { inputClassList } from '@/mixins/inputClassList.js'

export default {
  name: 'text-input',
  mixins: [inputClassList],
  props: {
    inputKey: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    isValidField: {
      type: Boolean,
      required: false,
      default: true
    },
    isRecommendedField: {
      type: Boolean,
      required: false,
      default: false
    },
    inputType: {
      type: String,
      required: false, 
      default: 'text'
    },
    getValueFromBackend: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
/*** Component Style ***/
.text-input {
  position: relative;
}
</style>